<style scoped>
.v-list__tile__action {
  justify-content: center;
}
</style>

<template>
  <router-link :to="to">
    <v-list>
      <v-list-tile>
        <v-list-tile-action>
          <v-icon>{{ icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </router-link>
</template>

<script>
export default {
  props: ["title", "icon", "to"]
};
</script>
